/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Your calibration and unit choice are saved in your browser's local storage, so the ruler stays correct the next time you open it on that device.`)
};

const es_ruler_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Tu calibración y la unidad elegida se guardan en el almacenamiento local de tu navegador, así que la regla sigue siendo correcta la próxima vez que la abras en ese dispositivo.`)
};

const de_ruler_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Deine Kalibrierung und Einheitenwahl werden im lokalen Speicher deines Browsers gespeichert, sodass das Lineal beim nächsten Öffnen auf diesem Gerät weiterhin korrekt ist.`)
};

const nl_ruler_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Je kalibratie en eenheidskeuze worden opgeslagen in de lokale opslag van je browser, zodat de liniaal de volgende keer dat je hem op dat apparaat opent nog steeds klopt.`)
};

const fr_ruler_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Votre calibration et le choix d'unité sont enregistrés dans le stockage local de votre navigateur, donc la règle reste correcte la prochaine fois que vous l'ouvrez sur cet appareil.`)
};

const it_ruler_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. La calibrazione e l'unità scelta vengono salvate nella memoria locale del browser, così il righello resta corretto la prossima volta che lo apri su quel dispositivo.`)
};

const pt_br2_ruler_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Sua calibração e a unidade escolhida ficam salvas no armazenamento local do navegador, então a régua continua correta na próxima vez que você abrir no mesmo aparelho.`)
};

const pt_ruler_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A sua calibração e a unidade escolhida ficam guardadas no armazenamento local do navegador, para que a régua continue correta da próxima vez que a abrir nesse dispositivo.`)
};

const ja_ruler_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。校正結果と単位設定はブラウザのローカルストレージに保存されるため、同じ端末で次回開いたときも正確な状態が保たれます。`)
};

const zh_ruler_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会的。你的校准结果和单位选择会保存在浏览器的本地存储中，下次在该设备上打开时标尺依然准确。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_faq_a3", locale)
	if (locale === "en") return en_ruler_faq_a3(inputs)
	if (locale === "es") return es_ruler_faq_a3(inputs)
	if (locale === "de") return de_ruler_faq_a3(inputs)
	if (locale === "nl") return nl_ruler_faq_a3(inputs)
	if (locale === "fr") return fr_ruler_faq_a3(inputs)
	if (locale === "it") return it_ruler_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_faq_a3(inputs)
	if (locale === "pt") return pt_ruler_faq_a3(inputs)
	if (locale === "ja") return ja_ruler_faq_a3(inputs)
	return zh_ruler_faq_a3(inputs)
};